<template>
  <ModalContainer
    v-model='modal'
    :image='modalIcon'
    :title="modalName"
  >
    <div v-if="!newTool">
      <p>{{ tool?.description }}</p>
      <div class="flex flex-row w-full mt-8 text-sm justify-around">
        <div @click="setStateWorks()" class="flex flex-col gap-2 items-center cursor-pointer">
          <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" :class="classes[1].icon"><path d="m422-395.33-94-94q-9.67-9.67-24-9.67t-24.67 10.33q-9.66 9.67-9.66 24 0 14.34 9.66 24l119.34 120q10 10 23.33 10 13.33 0 23.33-10L680-555.33q10.33-10.34 10.33-24.67 0-14.33-10.33-24.67-10.33-9.66-25-9.33-14.67.33-24.33 10L422-395.33ZM480-80q-82.33 0-155.33-31.5-73-31.5-127.34-85.83Q143-251.67 111.5-324.67T80-480q0-83 31.5-156t85.83-127q54.34-54 127.34-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 82.33-31.5 155.33-31.5 73-85.5 127.34Q709-143 636-111.5T480-80Zm0-66.67q139.33 0 236.33-97.33t97-236q0-139.33-97-236.33t-236.33-97q-138.67 0-236 97-97.33 97-97.33 236.33 0 138.67 97.33 236 97.33 97.33 236 97.33ZM480-480Z"/></svg>
          <div :class="classes[1].text">Works for me</div>
        </div>
        <div @click="setStateDoesnt()" class="flex flex-col gap-2 items-center cursor-pointer">
          <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" :class="classes[2].icon"><path d="m480-433.33 124.67 124.66Q614.33-299 628-299q13.67 0 23.33-9.67Q661-318.33 661-332q0-13.67-9.67-23.33L526.67-480l124.66-124.67Q661-614.33 661-628q0-13.67-9.67-23.33Q641.67-661 628-661q-13.67 0-23.33 9.67L480-526.67 355.33-651.33Q345.67-661 332-661q-13.67 0-23.33 9.67Q299-641.67 299-628q0 13.67 9.67 23.33L433.33-480 308.67-355.33Q299-345.67 299-332q0 13.67 9.67 23.33Q318.33-299 332-299q13.67 0 23.33-9.67L480-433.33ZM480-80q-82.33 0-155.33-31.5-73-31.5-127.34-85.83Q143-251.67 111.5-324.67T80-480q0-83 31.5-156t85.83-127q54.34-54 127.34-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 82.33-31.5 155.33-31.5 73-85.5 127.34Q709-143 636-111.5T480-80Zm0-66.67q139.33 0 236.33-97.33t97-236q0-139.33-97-236.33t-236.33-97q-138.67 0-236 97-97.33 97-97.33 236.33 0 138.67 97.33 236 97.33 97.33 236 97.33ZM480-480Z"/></svg>
          <div :class="classes[2].text">Doesn't work</div>
        </div>
        <div @click="setStateCant()" class="flex flex-col gap-2 items-center cursor-pointer">
          <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" :class="classes[3].icon"><path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-66.67q58.68 0 113-19.5 54.33-19.5 98.33-56.5L222.67-691.33q-36.34 44.66-56.17 98.78-19.83 54.11-19.83 112.55 0 139.58 96.87 236.46 96.88 96.87 236.46 96.87Zm256.67-122q35.66-44 56.16-98.33 20.5-54.32 20.5-113 0-139.58-96.87-236.46-96.88-96.87-236.46-96.87-58.44 0-112.55 19.83-54.12 19.83-98.78 56.83l468 468Z"/></svg>
          <div :class="classes[3].text">I can't do this</div>
        </div>
      </div>
    </div>
    <div v-else class="flex flex-col">
      <div class="w-full p-4 border-2 border-teal-200 bg-teal-100/20 rounded-lg">
        <div v-if="loading" class="flex flex-col items-center">
          <svg class="animate-spin h-12 w-12 m-8 text-teal-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <div>Unlocking your new tool!</div>
        </div>
        <div v-else>
          <div class="text-5xl">{{ tool?.icon }}</div>
          <h3>{{ tool?.name }}</h3>
          <p>{{ tool?.description }}</p>
        </div>
      </div>
      <button @click="closeModal()">I'll try it!</button>
      <button @click="unlockTool('works')" class="button-secondary">I already do this</button>
      <button @click="unlockTool('cant')" class="button-secondary">I can't do this</button>
    </div>
  </ModalContainer>
</template>

<script>
import ModalContainer from '@/components/ModalContainer'
import Tool from '@/models/tool'
import { dateToday } from '@/helpers/time'
import { mapStores } from 'pinia'
import { useUserStore } from '@/stores/user'

export default {
  name: 'ToolModal',
  components: {
    ModalContainer,
  },
  props: {
    modelValue: Boolean,
    toolObject: Object,
    newTool: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'update:modelValue',
    'update:toolObject',
  ],
  data() {
    return {
      defaultClasses: [
        {},
        {
          icon: ['fill-green-500'],
          text: ['text-current'],
        },
        {
          icon: ['fill-red-500'],
          text: ['text-current'],
        },
        {
          icon: ['fill-orange-500'],
          text: ['text-current'],
        },
      ],
      loading: false,
    }
  },
  beforeMount() {
  },
  watch: {
    modal: {
      handler() {
        if (this.modal === true) {
          localStorage.setItem('tool-' + this.tool.id + ':viewed', dateToday())
        }
      },
      immediate: true,
    },
  },
  methods: {
    closeModal() {
      this.modal = false
    },
    setStateWorks() {
      this.userStore.user.updateToolState(this.tool.id, Tool.STATE_WORKS)
      this.tool.state = Tool.STATE_WORKS
    },
    setStateDoesnt() {
      this.userStore.user.updateToolState(this.tool.id, Tool.STATE_DOESNT)
      this.tool.state = Tool.STATE_DOESNT
    },
    setStateCant() {
      this.userStore.user.updateToolState(this.tool.id, Tool.STATE_CANT)
      this.tool.state = Tool.STATE_CANT
    },
    async unlockTool(current) {
      this.loading = true
      // Set the state to `WORKS` if user already uses this tool or to `CANT`
      // if user can't use it.
      const state = current === 'works' ? Tool.STATE_WORKS : Tool.STATE_CANT
      await this.userStore.user.updateToolState(this.tool.id, state)

      // Unlock a new tool and update the data to show the new tool.
      this.tool = await this.userStore.user.unlockTool()
      const delay = ms => new Promise(res => setTimeout(res, ms))
      await delay(1000)
      localStorage.setItem('tool-' + this.tool.id + ':viewed', dateToday())
      this.loading = false
    },
  },
  computed: {
    modal: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      },
    },
    tool: {
      get() {
        return this.toolObject ? new Tool(
          this.toolObject.id,
          this.toolObject.key,
          this.toolObject.name,
          this.toolObject.description,
          this.toolObject.category,
          this.toolObject.unlockDate,
          this.toolObject.state,
        ) : null
      },
      set(value) {
        this.$emit('update:toolObject', value)
      },
    },
    classes() {
      if (this.tool?.state === null) return this.defaultClasses
      return this.defaultClasses.map(( value, index ) => {
        if (index === this.tool?.state) {
          return {
            icon: this.defaultClasses[this.tool.state].icon,
            text: ['text-current', 'font-bold'],
          }
        } else {
          return {
            icon: ['fill-gray-400'],
            text: ['text-gray-400'],
          }
        }
      })
    },
    modalIcon() {
      return this.newTool ? 'tool/unlocked.png' : this.tool?.icon
    },
    modalName() {
      return this.newTool ? 'You unlocked a new tool!' : this.tool?.name
    },
    ...mapStores(useUserStore),
  },
}
</script>